<template>
  
  <Row>
      <packageTable
        ref="contentBaseRef"
        class="contentBaseRef"
        :columnsData="columnsheader"
        :tableData="tableDataList"
        :reduceheight="reduceheight"
        :loading="tableLoading"
        :border="true"
        :tabletotallen="getPageTotal"
        :showSearchBtn="false"
        :tablePageSize="reqBase.page_size"
        @pageonChange="pageonChange"
        @pageSizeChange="pageSizeChange"
        @refreshBtn="init"
        @getSelect="getSelectList"> 
          <template slot="headLeft">
            <Form ref="formInline" :model="form_filter" class="tableHeaderForm" @keydown.enter.native="search" inline>
           
            
              <FormItem :label="this.$t('项目号')">
                  <Select v-model="form_filter.project_code"  filterable :placeholder="this.$t('请选择项目号')" style="width:150px">
                    <Option v-for="(item,i) in project_codeData" :key="i" :value="item.project_code">{{item.project_code}}</Option>
                  </Select>  
                </FormItem>

                <FormItem :label="this.$t('硬件版本号')">
                  <Select v-model="form_filter.hardware_ver"  filterable :placeholder="this.$t('请选择硬件版本号')" style="width:150px">
                    <Option v-for="(item,i) in hardware_verData" :key="i" :value="item.hardware_ver">{{item.hardware_ver}}</Option>
                  </Select>  
                </FormItem>
 
                <FormItem :label="this.$t('产品型号')">
                  <Select v-model="form_filter.model_code"  filterable :placeholder="this.$t('请选择产品型号')" style="width:150px">
                    <Option v-for="(item,i) in model_codeData" :key="i" :value="item.model_code">{{ item.name }} ({{item.model_code}})</Option>
                  </Select>  
                </FormItem>
              <FormItem class="reduceFromMarginLeft">
                  <Button v-for="(item,index) in topButtonList" :type="item.type"
                          style="margin-right: 5px;" @click="item.method" :key="index">{{item.name}}</Button>
              </FormItem>
            </Form>
          </template>
          <template slot="headRight">
              <!-- <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> -->
          </template>
          <template slot="headRight">
              <Tooltip v-for="(item,index) in topButtonList1" :key="index"  :content="item.name" placement="bottom">
                <Button  
                    :type="item.type"      
                    style="margin-right: 5px;" 
                    @click="item.method" 
                    :key="index" 
                    :icon="item.icon"></Button>
            </Tooltip> 
          </template>
      </packageTable>
  </Row>
</template>
<script>
import packageTableMixins from '@/mixins/packageTableMixins'
import customDetails from './components/customDetails.vue'
 import uploadCom from "./components/uploadCom"
import addCom from './components/addCom'  
import config from '@/config/index'
 
import {addfirmware_rule,getfirmware_rulelist,firmware_ruleupdate,deletefirmware_rule,get_type,set_default,protocol_add,dict_update,protocol_del,daoru,daochu,get_downloadtoken} from '@/api/jingxiaoshang'
export default {
name: "MechanismManage",
mixins: [packageTableMixins], 
data() { 
  return {   
    orgVersosn:[],
    origina_version: [],
    origina_version1:[],
    model_codeData: [],
    hardware_verData: [],
    project_codeData: [],
    firmwareData: [],
    product_type_codeData:[],
    country_codeData: [
      { "value":"xciot-prod-cnsz", "name": "中国区" },
      {"value":"xciot-prod-hk","name":"香港区"},
      { "value": "xciot-prod-eu", "name": "欧洲区" },
      {"value":"xciot-prod-us2","name":"美国区"}
    ], 	
    country_code2Data: [
    { "value":"86", "name": "中国" },
    ],
    form_filter:{
      product_type_code:"",
      xieyi_name: ""
    },
    //共用的查询与重置
    topButtonList:[
      {
        name:this.$t('查询'),
        type:'primary',
        method:this.search
      },
      {
        name:this.$t('重置'),
        type:'error',
        method:this.reset
      }
    ],
    //共用的右侧添加按钮
    topButtonList1: [
    {
        name:this.$t('add'),
        icon:'ios-add',
        type:'primary',
        method:this.add
      },
    // {
    //       name:this.$t('import'),
    //       icon:'ios-cloud-upload',
    //       type:'primary',
    //       method:this.daoru
    //     },
    //    {
    //       name:this.$t('export'),
    //       icon:'ios-cloud-download',
    //       type:'primary', 
    //       method:this.daochu
    //     },
   
      // {
      //   name:this.$t('refresh'),
      //   icon:'ios-refresh',
      //   type:'primary',
      //   method:this.init
      // }
    ],
    reqBase: {
      page:1,
      page_size: 15,
      firmware_code:''
    },
    status: true,//是否企业认证
    tableDataList: [],
    getPageTotal: 0,
    operationButtonList:[
              {
                name:this.$t('edit'), 
                type:'primary',
                icon:'',
                method:this.edit
      },
      {
                name:this.$t('delete'),
                type:'primary',
                icon:'',
                method:this.del
      },
      {
                name:this.$t('details'),
                type:'primary',
                icon:'',
                method:this.details
              },
          
    ],
    // operationButtonList1:[
    //   {
    //     name:this.$t('operationModule.submitReview'),
    //     type:'primary',
    //     icon:'',
    //     method:this.submitReview
    //   },
    // ],
    columnsheader: [
      // {
      //   align: 'center',
      //   title: '产品型号',
      //   minWidth:120,
      //   key: 'model_code',
      // },
      {
        align: 'center',
        title: this.$t('项目号'),
        key: 'project_code',
      },
      {
        align: 'center',
        title: this.$t('硬件版本号'),
        key: 'hardware_ver',
      },
      {
        align: 'center',
        title:this.$t('型号'),
        key: 'model_code',
      },
      {
        align: 'center',
        title: this.$t('开始升级时间'),
        key: 'starttime',
      },
      {
        align: 'center',
        title: this.$t('升级范围'),
        key: 'send_scope',
        render: (h, { row }) => {
              let sendList = [
                {
                  label: this.$t('指定设备'),
                  value:1
                },
              
                {
                  label:this.$t('全部设备'),
                  value:3
                }
              ];
              let result = sendList.filter(item=>item.value == row.send_scope);
              let show = result.length > 0 ? result[0].label : this.$t('其他'); 
              return h('div', show);
            }
      },
      {
        align: 'center',
        title: this.$t('状态'),
        key: 'state',
        render:(h,{row})=>{
              let result = '';
              if(row.state===1){
                result=this.$t('生效中')
              }else if(row.state===0){
                result=this.$t('失效')
              }
              return h("span",result);
            }
      },
      {
        align: 'center',
        title: this.$t('operation'),
        minWidth:150,
        key: 'Operating',
        render: (h, { row }) => {
          let arr=[]
          //this.operationButtonList = [];
          let list=this.operationButtonList[0];
            arr.push(h('Button', {
                    style: {marginLeft: '5px',marginBottom:'3px'},
                    props: {
                      type: list.type,
                      size: list.size ? list.size : 'small'
                    },
                    on: {
                      click: () => {
                        this.edit(row)
                      }
                    } 
            }, list.name));
           
            //删除
            //  list=this.operationButtonList[1];
            // arr.push(h('Button', {
            //         style: {marginLeft: '5px',marginBottom:'3px'},
            //         props: {
            //           type: 'error',
            //           size: list.size ? list.size : 'small'
            //         },
            //         on: {
            //           click: () => {
            //             this.del(row)
            //           }
            //         }
            // }, list.name));

           
 
 
          return h('div',{style:{padding:'5px'}},arr)
         // return h('div',arr)
        }
      },
    ],
  }
},
props:{
  reducehe:{},
  code:{}
},
components: {
  customDetails
},   
computed: {

},
  methods: {
    get_type() {
      get_type({"firmware_code":this.$route.query.firmware_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg; 
                this.product_type_codeData = res.body.product_type
                this.model_codeData = res.body.model_codeData
                this.hardware_verData = res.body.hardware_verData
                this.project_codeData = res.body.project_codeData
                this.firmwareData = res.body.firmwareData,
              //  this.origina_version = res.body.origina_version
              //  this.origina_version1 = res.body.origina_version
                this.orgVersosn = res.body.origina_version;//保存原版本的数据
            } else {
              vm.$Message.error(msg);  
              _this.buttonLoading = false;
            }
          });
    },
    /**
     * 导入
     */
     daoru(){
      let vm=this;
        let config={
          loading:true,
          width:600,
          render:(h)=>{     
            return h('div',[
              h('h3',this.$t('import')),
              h(uploadCom,{
                ref:'uploadCom',
                props:{
                  edit: false,
                  _vm:vm
                }
              })
            ])
          },
          onOk:function(){
            let _this=this;
            let obj=this.$refs.uploadCom;
            obj.checkForm().then(res=>{
              if(res){
                //提交请求
                let formModel =obj.formModel;
                let formData = new FormData()
                formData.append('filename',formModel.filename)
                daoru(formData).then(res=>{
                  if(res.result===0){ 
                    vm.$Message.success(res.errorMsg);
                    vm.$Modal.remove();
                    vm.init();
                  }else{
                    vm.$Message.error(res.errorMsg,5);
                    _this.buttonLoading = false;
                  }
                });
              }else{
                _this.buttonLoading=false;
              }
            });
          }
        };
        this.$Modal.confirm(config);
    },
    daochu() { 
      let vm = this
      let config = {
        title: this.$t('export'),
        loading: true,
        content: this.$t('dictmenu.sureexport'),
        onOk: function () {
          let _this = this
          // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {
                 
            get_downloadtoken().then(res => { 
            // console.log(res.result) 
            //     return
               _this.buttonLoading = false
               if (res.result === 0) {
               
                let downloadtoken = res.body.downloadtoken
                let params =
                  "?type=1&downloadtoken=" +
                   downloadtoken 
                 
                window.open("http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" + params)
                vm.$Modal.remove()
              } else {
                vm.$Message.error(res.errorMsg)
              }
            }) 
        } 
      }
      this.$Modal.confirm(config)
    },
     
 /**
     * 删除
     */
     del(row){
      let vm=this;
        this.$Modal.confirm({
        title:this.$t('delete'),
        content:this.$t('你确定要删除此条规则吗？'),
        loading:true,
        onOk:function(){
          let _this=this; 
          deletefirmware_rule({rule_code:row.rule_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
        }
      })
    },
    details(row){
      const routeData = this.$router.push({ path: '/protocolman/protocollist2', query: { xieyi_code: row.xieyi_code }})
      window.open(routeData.href, '_self') 
  },
    add(){
       let vm = this;
        let config = {
          loading: true,
          width: 500,
          render: (h) => {
          return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } }, this.$t('新增升级规则')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                          vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom, {
                  ref: 'addCom',
                  props: {
                      _vm: vm,
                      $store:vm.$store,
                      edit:false,
                      parent_code:'0',
                      parent_name: '无',
                      model_codeData: vm.model_codeData,
                      hardware_verData: vm.hardware_verData,
                      project_codeData: vm.project_codeData,
                      firmwareData: vm.firmwareData,
                    //  origina_version: vm.origina_version,
                     // origina_version1: vm.origina_version1,
                      orgVersosn:vm.orgVersosn
                  }
              }) 
          ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            let ref = this.$refs.addCom;

            let start=ref.start;
            let end=ref.end;
            let origina_version={};
            if(start && start.value){
              let _start={};
              _start['key']=start.key;
              _start['value']=start.value;
              origina_version['start']=_start;
            }else{
              let _start={};
              _start['key']=start.key;
              _start['value']=start.value;
              origina_version['start']=_start;
            }
            if(end && end.value){
              let _end={};
              _end['key']=end.key;
              _end['value']=end.value;
              origina_version['end']=_end;
            }else{
              let _end={};
              _end['key']=end.key;
              _end['value']=end.value;
              origina_version['end']=_end;
            }
            if((start && start.value) && !(end && end.value)){
              this.$Message.error('请选择升级规则');
              _this.buttonLoading=false;
              return;
            }
            console.log(origina_version);
            if(!(start && start.value) && !(end && end.value)){
              obj.formModel["origina_version"]="";
            }else{
              obj.formModel["origina_version"]=origina_version;
            }

            obj.checkForm().then(res => {
              
            if (res) { 
               obj.formModel.testids=obj.formModel.testids2.split('\n')
              addfirmware_rule({...obj.formModel}).then(res => {
              let msg=res.errorMsg;
              if (res.result === 0) {
                let msg=res.errorMsg;
                vm.$Message.success(msg);
                vm.$Modal.remove(); 
                vm.init()
              } else {
              vm.$Message.error(msg);
                _this.buttonLoading = false;
              }
            });
            } else {
                _this.buttonLoading = false;
            }
          });
          }
        };
        this.$Modal.confirm(config);
      },
    edit(row) {
        console.log('a',row)
        
        let vm=this;
        let config={
          loading:true,
          width:500,
          render:(h)=>{
            return h('div', [
              h('div', { style: { display: 'flex', justifyContent: 'space-between' } }, [
              h('h3', { style: { width: '100%', paddingBottom: '5px' } },this.$t('编辑升级规则')),
              h('icon', {
                  props: { type: 'md-close', size: '16' },
                  style: {
                      cursor: 'pointer'
                  },
                  on: {
                      'click': evt => {
                        vm.$Modal.remove()
                      }
                  }
              })
              ]),
              h('Divider',{
                  style:{
                      margin:'8px 0'
                  }
              }),
              h(addCom,{
                ref:'addCom',
                props:{
                  edit:true,
                  $store:vm.$store,
                  _vm: vm,
                  setData: row,
                  model_codeData: vm.model_codeData,
                  hardware_verData: vm.hardware_verData,
                  project_codeData: vm.project_codeData,
                  firmwareData: vm.firmwareData,
                //  origina_version: vm.origina_version,
                //  origina_version1:vm.origina_version1,
                  orgVersosn:vm.orgVersosn
                } 
              })
            ])
          },
          onOk: function () {
            let _this = this;
            let obj = this.$refs.addCom;
            let ref = this.$refs.addCom;
            obj.checkForm().then(res => {
            if (res) {
              //let { area_name, desc, area_code } = obj.formModel
              console.log("obj.formModel", obj.formModel) 
              if (obj.formModel.import_type == 1) {  //输入
                obj.formModel.testids=obj.formModel.testids2.split('\n')
              }


            let start=ref.start;
            let end=ref.end;
            let origina_version={};
            if(start && start.value){
              let _start={};
              _start['key']=start.key;
              _start['value']=start.value;
              origina_version['start']=_start;
            }else{
              let _start={};
              _start['key']=start.key;
              _start['value']=start.value;
              origina_version['start']=_start;
            }
            if(end && end.value){
              let _end={};
              _end['key']=end.key;
              _end['value']=end.value;
              origina_version['end']=_end;
            }else{
              let _end={};
              _end['key']=end.key;
              _end['value']=end.value;
              origina_version['end']=_end;
            }
            if((start && start.value) && !(end && end.value)){
              this.$Message.error('请选择升级规则');
              _this.buttonLoading=false;
              return;
            }
            console.log(origina_version);
            if(!(start && start.value) && !(end && end.value)){
              obj.formModel["origina_version"]="";
            }else{
              obj.formModel["origina_version"]=origina_version;
            }



              firmware_ruleupdate(obj.formModel).then(res => {
                let msg=res.errorMsg;
                if (res.result === 0) {
                  let msg=res.errorMsg;
                  vm.$Message.success(msg);
                  vm.$Modal.remove();
                  vm.init()
                } else {
                vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
              } else {
                  _this.buttonLoading = false;
              }
            });
          }
        };
        this.$Modal.confirm(config);
    },
   
    set_default(row) {
      // console.log(row)
      let vm=this;
        this.$Modal.confirm({
        title:'设为默认',
        content:'您确定要设置'+row.protocol_name+'为默认吗？',
        loading:true,
        onOk:function(){
          let _this=this;
          set_default({dict_code:row.dict_code}).then(res => {
            let msg=res.errorMsg;
            if (res.result === 0) {
                let msg=res.errorMsg; 
                vm.$Message.success(msg);
                vm.$Modal.remove();
                vm.init()
            } else {
              vm.$Message.error(msg); 
              _this.buttonLoading = false;
            }
          });
        }
      })
   
    },
 
    init() { 
      this.get_type();
    this.tableLoading = true;
    getfirmware_rulelist({...this.reqBase}).then(res => {
      this.tableLoading = false;
      this.tableDataList = [];     
      if (res.result === 0) {
        this.tableDataList = res.body.list || [];
        this.getPageTotal = res.body.total;
      }else{
        this.tableDataList = [];
        this.getPageTotal = 0;
        this.$Message.error(res.errorMsg);
      }
    }); 
    },
 
  search(){
    this.onSearch(this.form_filter);
  },
  reset() {
    this.form_filter={
      model_code:null,
      hardware_ver: null,
      project_code: null
    };
    this.search();
  },
},
  
mounted() {
 
    this.$set(this.reqBase,'firmware_code',this.$route.query.firmware_code)
 
  if(this.reducehe){
    this.reduceheight=this.reducehe
  }else{
     this.init();
  }
},
created() {
  // this.getPageSizeToStorage();
}
}
</script>
<style scoped>
.div2 {
  font-size: 15px;
  text-align: center;
}
.contentBaseRef /deep/ .headerWrapper{
  align-items: center;
}
</style>
